import HtmlElement from '../../../Elements/HtmlElement';
import Swiper from "swiper";

/**
 * HeaderSlider
 */
const HeaderSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		HEADERSLIDER: '.tx-ig-headerslider .swiper-container'
	};

	/**
	 * HeaderSlider
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class HeaderSlider extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			const $slides = this.$element.find('.headerslider-slide');
			const slidesCount = $slides.length;
			const self = this;

			const slider = new Swiper(this.$element, {
				spaceBetween: 0,
				slidesPerView: 1,
				grabCursor: slidesCount > 1,
				resistanceRatio: 0,
				parallax: true,
				effect: 'fade',
				loop: slidesCount > 1,
				autoHeight: true,
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				},
				speed: 2000,
				pagination: {
					el: `${Selector.HEADERSLIDER} .swiper-pagination`,
					clickable: true
				},
				on: {
					init() {
						self.handleNoMobileVideo();

						const $currentSlide = $(this.slides[this.activeIndex]);

						if ($currentSlide.length) {
							const $videoSlide = $currentSlide.find('.headerslider-slide.has-video');

							if ($videoSlide.length) {
								$videoSlide.find('video').get(0).play().catch(() => {});
							}
						}

						setTimeout(() => {
							this.update();
						}, 200);
					},
					slideChange: function() {
						const $previousSlide = $(this.slides[this.previousIndex]);

						if ($previousSlide.length) {
							const $videoSlide = $previousSlide.find('.headerslider-slide.has-video');

							if ($videoSlide.length) {
								if ($videoSlide.hasClass('no-mobile-video')) {
									if ($(window).width() > 800) {
										const video = $videoSlide.find('video').get(0);
										video.pause();
										video.currentTime = 0;
									}
								} else {
									const video = $videoSlide.find('video').get(0);
									video.pause();
									video.currentTime = 0;
								}
							}
						}

						const $currentSlide = $(this.slides[this.activeIndex]);

						if ($currentSlide.length) {
							const $videoSlide = $currentSlide.find('.headerslider-slide.has-video');

							if ($videoSlide.length) {
								if ($videoSlide.hasClass('no-mobile-video')) {
									if ($(window).width() > 800) {
										$videoSlide.find('video').get(0).play();
									}
								} else {
									$videoSlide.find('video').get(0).play();
								}
							}
						}
					}
				}
			});

			$(window).on('resize', () => {
				this.handleNoMobileVideo();
			});

			const intersectionCallback = (entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						slider.autoplay.start();
					} else {
						slider.autoplay.stop();
					}
				});
			};

			const observer = new IntersectionObserver(intersectionCallback, {
				threshold: 0.5
			});

			observer.observe(this.$element.get(0));
		}

		handleNoMobileVideo() {
			if ($(window).width() >= 800) {
				this.$element.find('.headerslider-slide.no-mobile-video').each((i, el) => {
					const $video = $(el).find('video');

					if (!$video.find('source').length) {
						$video.html(`<source src="${$video.data('src')}" type="${$video.data('type')}" />`);
					}
				});
			}
		}
	}

	return HeaderSlider._getElements(Selector.HEADERSLIDER, HeaderSlider);
})();

export default HeaderSlider;
